import { PermissionGroups } from './PermissionGroups';
import { FirmStatus, FirmType } from './constants';

/**
 * Groups allowed into LRNext > Legal Network (menu, routes and the API):
 * LRNext-Admin, LRNext-AttorneyRelations-Admin
 * and LRNext-AttorneyRelations-Contributor.
 * The API checks the same groups by ID in AuthIoc (PermissionGroupsIds).
 */
export const LegalNetworkGroups: PermissionGroups[] = [
  PermissionGroups.Admin,
  PermissionGroups.AttorneyRelationsAdmin,
  PermissionGroups.AttorneyRelationsContributor
];

export const LegalNetworkRoutes = {
  lawFirms: '/legal-network/law-firms',
  practiceAreas: '/legal-network/practice-areas',
  lawFirm: '/law-firm',
  lawFirmGroup: '/law-firm-group'
};

export const LegalNetworkMenu = {
  label: 'Legal Network',
  icon: 'mat:account_balance'
};

export const PracticeAreaListText = {
  title: 'Practice Areas'
};

export const LawFirmListText = {
  // The page header names the area; the table panel below it is the firm list itself.
  pageTitle: 'Law Firm Network',
  title: 'Law Firms',
  childOf: 'child of',
  showChildren: 'Show child firms',
  hideChildren: 'Hide child firms',
  open: 'Open',
  noMembers: '-',
  emptyFiltered: 'No law firms match the filters.',
  empty: 'No law firms found.'
};

export const LawFirmListFilterText = {
  all: 'All',
  search: 'Search',
  searchPlaceholder: 'Firm code, name or type...',
  firmType: 'Firm type',
  firmTypePlaceholder: 'Search type...',
  firmTypeNoMatch: 'No matching firm type',
  city: 'City',
  cityPlaceholder: 'Filter by city...',
  state: 'State',
  statePlaceholder: 'State, e.g. CA or California',
  status: 'Status',
  clear: 'Clear Filters',
  show: 'Edit Filters',
  hide: 'Hide Filters'
};

// The values FirmDetail.FirmType holds (dbo.DropDownValue, FirmDetail.FirmType).
export const LawFirmListFirmTypes: string[] = [FirmType.PAN, FirmType.NAC, FirmType.RAD, FirmType.Prospect];

export const LawFirmStatusOptions: { value: string | null; label: string }[] = [
  { value: null, label: LawFirmListFilterText.all },
  { value: FirmStatus.Active, label: 'Active' },
  { value: FirmStatus.Inactive, label: 'Inactive' },
  { value: FirmStatus.Hold, label: 'Hold' },
  { value: FirmStatus.Probation, label: 'Probation' }
];

// Same label colors as the Portal users table (green active, red inactive); statuses without a color fall back to gray.
export const LawFirmStatusLabelClasses: { [status: string]: string } = {
  [FirmStatus.Active]: 'bg-green-light text-green',
  [FirmStatus.Inactive]: 'bg-red-light text-red',
  [FirmStatus.Hold]: 'bg-orange-light text-orange',
  [FirmStatus.Probation]: 'bg-orange-light text-orange'
};
export const LawFirmStatusFallbackClasses = 'bg-gray-light text-gray';

export const LawFirmListIcons = {
  expand: 'expand_more',
  collapse: 'expand_less',
  clear: 'clear'
};

// usa-states holds what the user typed until a state is picked; only a two-letter code is sent as the filter.
export const StateCodePattern = /^[A-Za-z]{2}$/;

export const LawFirmListBreadcrumbs = [
  { label: LegalNetworkMenu.label, link: '' },
  { label: LawFirmListText.title, link: LegalNetworkRoutes.lawFirms }
];

export const LawFirmListColumns = {
  firm: 'Law firm',
  city: 'City',
  state: 'State',
  firmType: 'Firm type',
  status: 'Status',
  assignedMembers: 'Assigned members'
};

export const LawFirmListPaging = {
  pageSizes: [10, 25, 50, 100],
  defaultPageSize: 25,
  searchDebounceMs: 300
};
